// extracted by mini-css-extract-plugin
export default {"actualite":"Actualite_actualite__+Bk0N","blockImage":"Actualite_blockImage__onKtt","containte":"Actualite_containte__8eQwQ","description":"Actualite_description__HCc5w"};